var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHdlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 5416,
    height: 592,
    viewBox: "0 0 5416 592",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uBAA8\\uC591_1",
    "data-name": "\\uBAA8\\uC591 1",
    className: "cls-1",
    d: "M2708,588l96-28,28-92,64,24,92-112-68-72,16-228L2708,4,2480,80l16,228-68,72,92,112,64-24,28,92,96,28M2584,284c78.03-.745,82.39,119.213,0,120C2504.23,404.762,2504.23,284.762,2584,284Zm248,0c78.03-.745,82.39,119.213,0,120C2752.23,404.762,2752.23,284.762,2832,284Zm148-28,12-176H5416L5268,256H2980Zm24,52,56,64H5172l52-64H3004Zm24,116-60,68h652l56-68H3028Zm728,0-60,68h652l56-68H3756ZM2436,256L2424,80H0L148,256H2436Zm-24,52-56,64H244l-52-64H2412Zm-24,116,60,68H1796l-56-68h648Zm-728,0,60,68H1068l-56-68h648Zm1048,32,20,24,20-20-40-60-40,60,20,20,20-24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdlogo);
export default __webpack_public_path__ + "static/media/hdlogo.b63829bf2f80b8d07819503494863b96.svg";
export { ForwardRef as ReactComponent };